export default __webpack_public_path__ + "static/mobile_dock-c82c880a8a93e6bb5c34333ef199bab3.png";